/**
 * AboutPage React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

// 3rd party
import ReactMarkdown from 'react-markdown';

// application
import WarningPanel from "../base/WarningPanel";
import {fetchJSON} from "../../operations/communication";
import {
    REST_CALL_GET_ABOUT_INFO,
    REST_SERVER_BASE_URL
} from "../../config";


const isoDatePattern = /^\d\d\d\d-\d\d-\d\d/;


function formatTextList(header, texts) {
    return texts ? header + texts.map(text => "* " + text + "\n").join("\n") : "";
}

function formatHistory(item) {

    const versionPart = "## Version " + item.version + "\n\n";
    const datePart = item.date ? "##### " + (
        isoDatePattern.test(item.date) ? new Date(item.date).toLocaleDateString() : item.date
    ) + "\n\n" : "";
    const newsPart = formatTextList("### Neuigkeiten\n\n", item.news);
    const improvementsPart = formatTextList("### Verbesserungen\n\n", item.improvements);
    const correctionsPart = formatTextList("### Korrekturen\n\n", item.corrections);

    return versionPart + datePart + newsPart + improvementsPart + correctionsPart;
}


class AboutPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            disconnected: false,
            waiting: true,
            version: undefined,
            history: [],
            historyTexts: []
        }
    }

    componentDidMount() {
        this.refreshData();
    }

    async refreshData() {
        
        const result = await this.fetchAboutInfo();
        const version = result.version || '?';
        const history = result.history || [];
        const historyTexts = history.map(item => formatHistory(item));

        if (result) {
            this.setState({
                disconnected: false,
                waiting: false,
                version: version,
                history: history,
                historyTexts: historyTexts
            });
        }
        else {
            this.setState({
                disconnected: true,
                waiting: false
            });
        }
    }

    render() {

        const {classes} = this.props;
        const {tabIndex} = this.state;

        if (this.state.disconnected) return <WarningPanel text="Verbindung zum Server unterbrochen!" />;

        if (this.state.waiting) return <CircularProgress className={classes.progress} />;

        return <div>
            <Tabs value={tabIndex} onChange={(event, index) => this.setState({tabIndex: index})}>
                <Tab label="Version" />
                <Tab label="Historie" />
            </Tabs>

            {
                tabIndex === 0 && <Card className={classes.cardFrame}>
                    <Typography>{"Version " + this.state.version}</Typography>
                </Card>
            }
            {
                tabIndex === 1 && this.state.historyTexts.map((text, index) => <Card key={index} className={classes.cardFrame}>
                    <ReactMarkdown className="markdown" source={text} />
                </Card>)
            }
        </div>;
    }

    async fetchAboutInfo() {
        try {
            const result = await fetchJSON(
                REST_SERVER_BASE_URL + REST_CALL_GET_ABOUT_INFO.path, {
                    method: REST_CALL_GET_ABOUT_INFO.method,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + this.props.accessToken
                    }
                }
            );
            return result;
        }
        catch (error) {
            return null;
        }
    }
}

const styles = theme => ({
    cardFrame: {
        marginTop: theme.spacing.unit,
        padding: 24
    },
    progress: {
        display: "block",
        margin: "16px auto"
    }
});

const mapStateToProps = state => {
    return {
        accessToken: state.authorization.accessToken
    }
};

export default connect(mapStateToProps)(withStyles(styles)(AboutPage));
